import { addDays, differenceInMilliseconds } from 'date-fns';

const formatTimeRemaining = (milliseconds) => {
  const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (milliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));

  return `${days}d ${hours}h:${minutes}min`;
};

const getTimeRemaining = ({ endDate, daysExtended = 0 }) => {
  const now = new Date();
  let end = new Date(endDate);

  if (daysExtended > 0) {
    end = addDays(end, daysExtended);
  }

  const timeRemaining = differenceInMilliseconds(end, now);
  return formatTimeRemaining(timeRemaining);
};

export default getTimeRemaining;
